import React, { useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import "bootstrap/dist/css/bootstrap.css";
import { ServiceManager } from "../../../services/ServiceManager";
import { Button } from "react-bootstrap";
import PagedFilterTable from "../../../components/table";
import { useParams } from "react-router-dom";
import IEstablishmentProduct from "../../../models/EstablishmentProduct";

interface IEstablishmentProductsListProps {
    handleClose: any;
    handleProductFilter: any;
    selectedProduct: any;
}
export default function EstablishmentProductsList(props: IEstablishmentProductsListProps) {
    const { EstablishmentId } = useParams();
    const [rowSelection, setRowSelection] = useState(props.selectedProduct);
    const columnHelper = createColumnHelper<IEstablishmentProduct>();
    const columns = [
        columnHelper.display({
            id: "select_productID",
            cell: props => <input type="checkbox" aria-label={`Select ${props.row.original.productName}`} checked={rowSelection === props.row.original} onChange={(e) => { onRowClick(props.row); }}></input>
        }),
        columnHelper.accessor('productName', {
            header: () => <span>Name</span>,
            size: 50,
            cell: ({ row }) => (
                <div >
                    <span >{row.original.productName}</span>
                </div>
            ),
        }),
        columnHelper.accessor('productId', {
            header: () => <span>ID</span>,
            size: 50,
            cell: ({ row }) => (
                <div >
                    <span >{row.original.productId}</span>
                </div>
            ),
        })
    ];

    function onRowClick(row: any) {
        const selectedValue = row.original;
        setRowSelection((prevValue : any) => (prevValue === selectedValue ? null : selectedValue));
    }

    async function fetchData(options: {
        pageIndex: number;
        pageSize: number;
        searchValue: string;
    }) {
        const establishmentResponse = await ServiceManager.EstablishmentService.GetProductsById(EstablishmentId);
        return establishmentResponse.data.filter((product : any) => product.installed === true || product.allowed === true);
    }

    function onClose() {
        try {
            props.handleClose();
        } catch (e) {
            console.error(e);
        }
    }

    function handleApply() {
        try {
            props.handleProductFilter(rowSelection);
            props.handleClose();

        } catch (e) {
            console.error(e);
        }
    }

    return (
        <React.Fragment>
            <div id="establishmentFilterTable">
                <PagedFilterTable
                    tableKey={`establishment-products-filter-${EstablishmentId}`}
                    columns={columns}
                    data={[]}
                    usePagination={false}
                    useSearch={false}
                    pageRecords={8}
                    fnFetchData={fetchData}
                />
            </div>
            <div className="mt-4">
                <Button
                    variant="popup-btn right-margin10 btn-outline-secondary"
                    onClick={() => onClose()}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    variant="popup-btn btn btn-primary crbc-bg-color "
                    className={` ${rowSelection ? "" : "disabled"}`}
                    onClick={() => handleApply()}
                >
                    Apply
                </Button>
            </div>
        </React.Fragment>
    )
};